<template>
  <article :class="{'-selected': markAsSelected}">
    <header>
      <h2 class="label">
        <a :href="vehicleLink">{{ vehicle.label }}</a>
      </h2>
      <div class="subheading">
        CAT. {{ vehicle.rrs_category.label }} - {{ licenceAge }}
      </div>
      <vehicle-capacities
        :vehicle="vehicle"
      />
    </header>
    <div class="selected-icon-wrapper">
      <svg class="selected-icon">
        <use xlink:href="#icon-cart"></use>
      </svg>
    </div>
    <div class="image-wrapper">
      <a
        :href="`/vehicules/${vehicle.slug}`"
        class="link"
        :aria-label="vehicle.label"
      >
        <img
          :src="imageSrc"
          width="360"
          class="image"
          alt=""
        >

      </a>
      <a
        v-if="promoEnabled"
        class="promo-banner"
        :href="vehicle.promotion.url"
        :style="'background-color:' + vehicle.promotion.color"
        :target="vehicle.promotion.url_target == 2 ? '_blank ': '_self'"
      >{{ vehicle.promotion.label }}</a>
    </div>
    <div class="bottom">
      <div class="price-txt">
        <div
          class="displayed-price"
          v-html="priceTxt"
        />
        <div
          v-show="pricePerDay"
          class="price-per-day"
          v-html="pricePerDay"
        />
      </div>
      <div
        v-show="agencyPrice"
        class="agency-price"
        v-html="agencyPrice"
      />
      <div class="availability-wrapper">
        <vehicle-availability
          :vehicle="vehicle"
          :payment="usePayment"
        />
      </div>
      <div
        v-if="plan"
        class="plan"
      >
        {{ $t('commons.plan') }} {{ plan }}
      </div>
      <div class="buttons">
        <rent-button
          class="vehicle-card-button"
          :href="`/vehicules/${vehicle.slug}`"
          is-anchor
          grey
        >
          {{ $t('commons.details') }}
        </rent-button>
        <rent-button
          :loading="attemptingNavigation && markAsSelected"
          @buttonclicked="selectVehicle"
          class="vehicle-card-button"
          is-anchor
        >
          {{ $t('commons.select') }}
        </rent-button>
      </div>
    </div>
  </article>
</template>
<script>
import RentButton from '../shared/RentButton'
import VehicleCapacities from '../shared/vehicleElements/VehicleCapacities'
import vehicleCard from '../shared/mixins/vehicleCards'

export default {
  name: 'VehicleCard',
  mixins: [vehicleCard],
  data() {
    return {
      priceHasFootNote: true,
    }
  },
  components: {
    RentButton,
    VehicleCapacities,
    VehicleAvailability: () => import(/* webpackChunkName: "availability"  */ `../shared/vehicleElements/VehicleAvailability`),
  },
  props: {
    vehicle: {
      type: Object,
      required: true,
    },
    availability: {
      type: Number,
      default: null,
    },
  },
  computed: {
    formElement() {
      return this.$store.state.ui.formElement
    },
    licenceAge() {
      return `${this.$t('pages.vehicles.licence_years')} : ${this.vehicle.rrs_category.minimum_driving_licence_years}+`
    },
  },
  methods: {
    scrollToForm() {
      if (this.formElement) this.formElement.scrollIntoView({ behavior: 'smooth' })
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../../../_src/sass/config/vars";
@import "../../../../_src/sass/config/mixins";

article {
  border: 1px solid #eae9e8;
  color: #000;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  max-width: 400px;
  min-height: 485px;
  overflow: hidden;
  padding: 20px 0;
  position: relative;
  transition: border-color 150ms ease-out;

  &.-selected {
    border-color: $orange;
  }
}

header {
  padding: 0 20px;
  position: relative;
}

.label {
  &,
  & a {
    color: black;
    font-family: $f-graphie-semibold;
  }

  font-weight: normal;
  margin: 0;
  margin: 0 0 5px;
  text-transform: uppercase;

  @include font-size(16px);
}

.subheading {
  @include font-size(14px);

  margin: 0 0 5px;
}

.selected-icon-wrapper {
  align-items: center;
  background: $orange;
  display: flex;
  height: 60px;
  justify-content: center;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  right: 0;
  top: 60px;
  transition: opacity 150ms ease-out, width 150ms ease-out;
  width: 0;

  .-selected & {
    opacity: 1;
    width: 60px;
  }
}

.selected-icon {
  fill: white;
  max-height: 24px;
  max-width: 24px;
}

.bottom {
  padding: 0 20px;
}

.price-txt {
  @include font-size(16px);

  display: flex;
}

.price-txt ::v-deep span {
  @include font-size(16px);
}

.displayed-price {
  color: black;
  font-family: $f-graphie-semibold;
}

.price-per-day {
  color: black;
  margin: 0 0 0 5px;
  text-transform: uppercase;
}

.price-per-day ::v-deep span {
  @include font-size(13px);
}

.buttons {
  display: flex;
  justify-content: space-between;
  margin: 10px 0 0;
}

.vehicle-card-button {
  max-width: calc(50% - (15px / 2));
}

img {
  margin: auto;
}

.plan {
  font-family: $f-graphie-book;
  font-size: 1.4rem;
  line-height: 2rem;
}

.image-wrapper {
  box-sizing: border-box;
  margin: 2rem 0;
  overflow: hidden;
  padding-top: 3rem;
  position: relative;

  &::before {
    content: "";
    display: block;
    padding-top: (197 / 383) * 100%;
    width: 100%;
  }
}

.link {
  display: block;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.image {
  display: block;
  height: 80%;
  object-fit: cover;
  width: 100%;
}

.promo-banner {
  background: #fc3;
  bottom: 32px;
  color: #201906;
  font-size: 0.875em;
  left: -42px;
  line-height: 1;
  padding: 6px 30px;
  position: absolute;
  text-align: center;
  text-transform: uppercase;
  -webkit-transform: perspective(1px) rotate(45deg);
  transform: perspective(1px) rotate(45deg);
  width: 180px;

  @include font-size(13px);

  &:hover {
    color: white;
  }
}
</style>
